var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#2F4DC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0643 9.58554L15.4421 7.9551C15.3349 7.84845 15.1899 7.78857 15.0386 7.78857C14.8874 7.78857 14.7424 7.84845 14.6352 7.9551L8.88439 13.6976L8.35933 15.9636C8.34122 16.0465 8.34184 16.1323 8.36115 16.2149C8.38046 16.2974 8.41797 16.3746 8.47094 16.4409C8.52391 16.5071 8.591 16.5606 8.66731 16.5976C8.74363 16.6345 8.82723 16.654 8.91202 16.6545C8.95153 16.6585 8.99135 16.6585 9.03085 16.6545L11.3218 16.1294L17.0643 10.3925C17.1709 10.2853 17.2308 10.1402 17.2308 9.98901C17.2308 9.8378 17.1709 9.69274 17.0643 9.58554ZM11.0454 15.632L8.89821 16.0825L9.38734 13.9767L13.6901 9.69056L15.3481 11.3486L11.0454 15.632ZM15.7185 10.9479L14.0604 9.28985L15.0221 8.33369L16.6525 9.99177L15.7185 10.9479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicEdit);
export default __webpack_public_path__ + "static/media/picEdit.d3dbc3909ac923dea10cdc18cca6ef58.svg";
export { ForwardRef as ReactComponent };